import { ProfilePageParam } from '../../types/navigation/params';

export const getProfileLinkWithParams = (page = ProfilePageParam.MAIN) => {
  return `/profile/${page}`;
};
